import styled from "styled-components";
import { colorPalette, typeScale } from "../../utils/theme";

export const HeaderContainer = styled.div`
  margin-top: 32px;

  @media (max-width: 992px) {
    margin-top: 0;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingMain}

  @media (max-width: 767.98px) {
    ${typeScale.headingSMMain};
  }
`;

export const ArticleScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding-bottom: 16px;
  max-width: 100%;
  padding-right: 10%; /* Allow space to show part of the next card */
  white-space: nowrap; /* Prevent wrapping */

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 1024px) {
    max-width: 100%;
    justify-content: flex-start;
    overflow-x: auto; /* Ensure scrolling is possible */
    white-space: nowrap; /* Prevent flex from breaking the layout */
  }

  @media (max-width: 992px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const ArticleCard = styled.div`
  flex: 0 0 48%; /* Each card takes 48% to leave space for the next */
  max-height: 160px;
  display: flex;
  background-color: ${colorPalette.white};
  border: 1px solid ${colorPalette.blue200};
  border-radius: 8px;
  margin-right: 16px;
  overflow: hidden;
  min-width: 48%; /* Ensures items do not shrink */

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 992px) {
    flex: 0 0 85%; /* Responsive layout for mobile */
    margin-right: 16px;
    max-height: 140px;
  }

  @media (min-width: 1024px) {
    flex: 0 0 46%; /* Allow part of the third item to be visible */
    min-width: 46%; /* Ensures items take proper space */
  }
`;

export const ArticleImage = styled.img`
  width: auto;
  height: 100%;
  object-fit: cover;
  max-height: 160px; /* Match max height of ArticleCard */

  @media (max-width: 767.98px) {
    width: 40%; /* Reduce width on mobile */
    max-height: 140px; /* Adjust for mobile screens */
  }
`;

export const ArticleContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1; /* Allow content to take remaining space */
  min-width: 50%;
  max-height: 160px; /* Ensure consistent height */

  @media (max-width: 992px) {
    padding: 8px;
    max-height: 140px; /* Adjust for mobile screens */
  }
`;

export const ArticleTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`;

export const ArticleTitle = styled.h3`
  color: ${colorPalette.textMain};
  margin: 4px 0;
  ${typeScale.headingSMMain}

  @media (max-width: 767.98px) {
    ${typeScale.headingXXSMain};
  }
`;

export const ArticleSubtitle = styled.p`
  color: ${colorPalette.textDark};
  margin: 0;
  ${typeScale.bodyXS}

  @media (max-width: 767.98px) {
    ${typeScale.bodyXXS};
  }
`;

export const ArticleAdditionalText = styled.p`
  color: ${colorPalette.textDark};
  margin: 0;
  ${typeScale.bodyXXS}
`;
